/**
 * Contact Map Component
 * 
 * Displays an embedded Google Maps iframe showing the business location.
 * 
 * Features:
 * - Responsive map that fills its container
 * - Lazy loading for better performance
 * - Full-screen capability for better viewing
 * - Accessible title for screen readers
 * - Security settings (referrer policy)
 * 
 * The map provides customers with:
 * - Visual representation of the business location
 * - Ability to get directions
 * - Context about the surrounding area
 * 
 * @component
 * @returns {JSX.Element} Embedded Google Maps iframe
 */

import React from 'react';
import './contact-map-style.css';

const ContactMap = () => {
  return (
    <div className="contact-map">
      <div className="contact-map__container">
        {/* 
          Google Maps iframe
          - src: Embedded map URL with specific coordinates
          - width/height: 100% to be responsive
          - allowFullScreen: Enables full-screen viewing
          - loading="lazy": Improves page load performance
          - referrerPolicy: Security setting for cross-origin requests
          - title: Accessibility description for screen readers
        */}
        <iframe
          src="https://maps.google.com/maps?q=9.9167954,-84.5196893&z=17&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Ubicación de Gemelas Villalobos"
        ></iframe>
        
      </div>
    </div>
  );
};

export default ContactMap;
